"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.VISIT_TYPE_CONTENT_HEIGHT = exports.SIDEBAR_WIDTH = exports.HEADER_HEIGHT = exports.BUTTON_WIDTH = void 0;
/*
screen size breakpoint values come from `@kyruus/ui-theme`
{
  db_screen_xsmall: '420px',
  db_screen_small: '768px',
  db_screen_medium: '992px',
  db_screen_large: '1200px'
}
*/

const SIDEBAR_WIDTH = exports.SIDEBAR_WIDTH = '18rem';
const HEADER_HEIGHT = exports.HEADER_HEIGHT = '6rem';
const VISIT_TYPE_CONTENT_HEIGHT = exports.VISIT_TYPE_CONTENT_HEIGHT = '10rem';
const BUTTON_WIDTH = exports.BUTTON_WIDTH = '8rem';